module.exports = __webpack_public_path__ + "assets/img/1.5b0a0109.jpg";